import React, {useEffect, useState} from "react";
import {createCalculatedColumn, createColumn, createComponentColumn} from "../../utils/ColumnUtils";
import EATable from "../../components/EATable";
import {useHttp} from "../../services/HttpService";
import {getIndirekteinleiter} from "../../services/AnlagenService";
import EABetriebsakteMainContainer from "../../components/betriebsakte/EABetriebsakteMainContainer";
import {Link} from "react-router-dom";
import {calculateAnlagenLink} from "../../initialObjects/AnlageObjects";
import {FormControlLabel, Switch} from "@material-ui/core";

function IndirektEinleiterView(props) {
    const [{data, loading}] = useHttp(getIndirekteinleiter(props.match.params.anlageid));
    const [filteredData, setFilteredData] = useState([]);
    const [showOwnIndirekteinleiter, setShowOwnIndirekteinleiter] = useState(false);

    useEffect(() => {
        if (loading) {
            setFilteredData([]);
        } else if (showOwnIndirekteinleiter) {
            setFilteredData(data.slice());
        } else {
            const onlyForeignIndirekteinleiter = data.slice().filter((item) => {
                const ownBetriebId = Number(props.match.params.id);
                return item.betrieb?.id !== ownBetriebId;
            });
            setFilteredData(onlyForeignIndirekteinleiter);
        }
    }, [data, loading, showOwnIndirekteinleiter, props.match.params.id]);

    const updateShowOwnIndirekteinleiter = () => {
        const newVal = !showOwnIndirekteinleiter
        setShowOwnIndirekteinleiter(newVal);
    };

    const linkColumnComponentProvider = (row) => {
        const path = calculateAnlagenLink(row);
        return (
            <Link to={path}>
                {row.bezeichnung}
            </Link>
        );
    };

    const anlageColumns = [
        createComponentColumn(
            "bezeichnung",
            linkColumnComponentProvider,
            "Abwasseranlage"
        ),
        createColumn("anlagentyp.value", "Anlagentyp"),
        createCalculatedColumn(
            "betrieb.bezeichnung",
            (anlage) => anlage.betrieb.value,
            "Betrieb"
        ),
        createColumn("anlagenstatus.value", "Status"),
    ];

    return (
        <div className={"viewScrollContainer"}>
            <EABetriebsakteMainContainer className={"tabsheet-content-margin"}>
                <FormControlLabel
                    control={
                        <Switch
                            value={showOwnIndirekteinleiter}
                            onChange={updateShowOwnIndirekteinleiter}
                        />}
                    label="Indirekteinleiter eigener Betrieb anzeigen"
                    style={{paddingLeft: "1em"}}
                />
                <EATable id={"indirekteinleiter"} loading={loading} initialSortColumn="bezeichnung" columns={anlageColumns}
                         data={filteredData}/>
            </EABetriebsakteMainContainer>
        </div>
    );
}

export default IndirektEinleiterView;
